import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Refuges from "./sections/Refuges";
import TheRefugesWeProtect from "./sections/TheRefugesWeProtect";
import Purpose from "./sections/Purpose";
import Impact from "./sections/Impact";
import Voices from "./sections/Voices";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Refuges />
      <TheRefugesWeProtect />
      <Purpose />
      <Impact />
      <Voices />
      <Action />
      <Footer />
    </div>;
}